<fhm-page [title]="'fhm.invoicesReport.title'" [showDone]="true"
          [showSave]="false"
          (doneClicked)="done()"
          [description]="description">

    <fui-rows>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <fhm-provision-button [title]="'fhm.common.label.downloadReport'" (clicked)="downloadReport()"></fhm-provision-button>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>

</fhm-page>
